module.exports = __webpack_public_path__ + "img/69.14cce7f9.jpg";